module.exports = __webpack_public_path__ + "static/media/data_results_fundo.25e7d6ef.png";